import { BIZ_CODE } from '@/common/constants';
import { request } from 'src/utils/request';

const urls = {
  taskList: '/zlb/operation/implement/task/list', // 分页获取任务列表
  taskDetail: '/zlb/operation/implement/task/detail', // 获取实施任务详情
  createTask: '/zlb/operation/implement/task/create', // 创建实施任务
  batchExecute: '/zlb/operation/implement/task/execute/batch', // 批量执行任务
  excelCommit: '/api/user/import/excel/commit', // Excel 处理提交接口
  institutionList: '/zlb/operation/implement/institution/query', // 单位下拉接口
  excelRes: '/api/user/import/v2/excel/result/', // excel 轮询解析
  taskCheck: '/zlb/operation/implement/task/check', // 实施任务检测流程触发
};

/**
 * 分页获取任务列表
 * @param data
 * @returns
 */
export function getTaskList(params) {
  return request(urls.taskList, { method: 'GET', params });
}

/**
 * 获取实施任务详情
 * @param params
 * @returns
 */
export function getTaskDetail(params) {
  return request(urls.taskDetail, { method: 'GET', params });
}

/**
 * 创建实施任务
 * @param data
 * @returns
 */
export function createTask(data) {
  return request(urls.createTask, { method: 'POST', data });
}

/**
 * 批量执行任务
 * @param data
 * @returns
 */
export function batchExecute(data) {
  return request(urls.batchExecute, { method: 'POST', data });
}

/**
 * 单位下拉
 * @param params
 * @returns
 */
export async function institutionList(params) {
  return request(urls.institutionList, { method: 'get', params });
}

/**
 * excel结果查看
 * @param params
 * @returns
 */
export async function excelResult(params) {
  return request(urls.excelRes, { method: 'GET', params });
}

/**
 * 文件流上传（加密上传）
 */
export async function uploadEncryptedFile(data) {
  return request('/zlb/api/fileServer/secure/upload', {
    data,
    method: 'POST',
    bizCode: BIZ_CODE,
    headers: {
      'Content-type': 'multipart/form-data',
    },
  });
}

export function excelCommit(data) {
  return request(urls.excelCommit, { method: 'POST', data });
}

/**
 * 区划单位表格数据
 */
export function districtInstitutionList(params) {
  return request('/zlb/operation/implement/institution/list', { method: 'get', params });
}

/**
 *  预算一体化机构下级单位列表
 */
export function budgetOrgTableList(params) {
  return request('/zlb/operation/implement/institution/budget/query', { method: 'get', params });
}

export function taskCheck(data) {
  return request(urls.taskCheck, { method: 'POST', data });
}
